import _ from "lodash";
import React from "react";
import { Modal, Button, MediaCard } from "@toddle-edu/ds-web";
import classes from "./RejectedFilesModal.scss";
import { formatBytes } from "Utils";

const DIALOG_INFO = {
  DEFAULT: {
    header: ({ t }) => t("common:file_size_limit_exceeded"),
    body: ({ t }) =>
      t("common:file_size_limit_exceeded_description_with_size", {
        size: "200MB",
      }),
    button2: ({ t }) => t("common:continue_anyway"),
  },
  INVALID_PROFILE_IMAGES: {
    // Currently used internally so not localized
    header: () => "Invalid files",
    body: ({ size }) => (
      <>
        {"These files are not valid due to one of the following reasons:"}
        <div>{"1. Unsupported file type"}</div>
        <div>{"2. Duplicate file name"}</div>
        <div>{`3. File size exceeds maximum allowed size (${size})`}</div>
        <div>{"4. No UID associated with the file name"}</div>
      </>
    ),
    button2: () => "Ignore and continue",
  },
};

const RejectedFilesModal = ({
  handleButton1Click,
  handleButton2Click,
  rejectedFiles,
  maxSize,
  isFileNameValidation,
  t,
  testId,
}) => {
  const dialogType = isFileNameValidation
    ? "INVALID_PROFILE_IMAGES"
    : "DEFAULT";

  const megabytes = maxSize ? formatBytes({ bytes: maxSize }) : "200MB";
  const { header, body, button2 } = DIALOG_INFO[dialogType];

  return (
    <Modal
      width="560px"
      height="max-content"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <Modal.Header title={header({ t })} isClosable={false} />
      <Modal.Body>
        <div className={classes.subtitle}>{body({ t, size: megabytes })}</div>
        {!_.isEmpty(rejectedFiles) ? (
          <div className={classes.fileListContainer}>
            {_.map(rejectedFiles, (file, index) => (
              <MediaCard
                key={index}
                mimeType={file.mimeType}
                name={file.name}
                type={file.type}
                size={file.size}
              />
            ))}
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            size="large"
            variant="outlined-subtle"
            onClick={handleButton1Click}
            testId={`${testId}-footer-cancel`}
          >
            {t("common:cancel")}
          </Button>
          <Button
            size="large"
            variant="progressive"
            onClick={handleButton2Click}
            testId={`${testId}-footer-ignoreAndContinue`}
          >
            {button2({ t })}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectedFilesModal;
